// The minimum length behind every admin list search. Extracted so the Players
// and Guilds lists draw the same line, and so it reads next to the reason.

/**
 * The shortest term a list search sends to the server.
 *
 * The search is a substring of a name, served by a trigram index — and a
 * pattern shorter than a trigram has nothing for that index to look up. The
 * database then either reads the whole table or asks the index for every row
 * and throws them away one by one: 46 ms and 221 ms on the measurement dataset,
 * against 0.4 ms for a term that has a trigram in it (docs/performance-audit.md).
 *
 * The API draws the same line one layer down — a short term there searches the
 * exact columns only — so this is not the guard, it is the half of it that
 * keeps the request from being made at all.
 */
export const SEARCH_MIN_LENGTH = 3;

/**
 * Whether a search term is below SEARCH_MIN_LENGTH once trimmed.
 *
 * An empty box is not "too short": it is not a search at all, and the list
 * shows the whole project for it. The length is counted in characters rather
 * than in the UTF-16 units `String.length` returns, which is what makes "Фёд"
 * three characters here and three runes in the store.
 */
export function isSearchTooShort(q: string): boolean {
  const trimmed = q.trim();
  return trimmed.length > 0 && [...trimmed].length < SEARCH_MIN_LENGTH;
}
